import React, {useMemo} from 'react';
import ReactApexChart from 'react-apexcharts';

const InvoicesChart = ({_ = [], periodType, loading}) => {
  // Dummy data for demonstration
  const dummyData = [
    {date: '2025-01-01', inFlow: 5200, outFlow: 1100},
    {date: '2025-02-01', inFlow: 6800, outFlow: 3900},
    {date: '2025-03-01', inFlow: 6100, outFlow: 3400},
    {date: '2025-04-01', inFlow: 3900, outFlow: 7600},
    {date: '2025-05-01', inFlow: 5500, outFlow: 1200},
    {date: '2025-06-01', inFlow: 1200, outFlow: 4100},
    {date: '2025-07-01', inFlow: 6300, outFlow: 3600},
    {date: '2025-08-01', inFlow: 4100, outFlow: 8700},
  ];

  const sortedData = dummyData.sort(
    (a, b) => new Date(a.date) - new Date(b.date),
  );

  // Simplified period formatting for dummy data
  const getPeriod = (date, type) => {
    const d = new Date(date);
    switch (type) {
      case 'daily':
        return d.toLocaleDateString();
      case 'monthly':
        return d.toLocaleString('default', {month: 'short', year: 'numeric'});
      case 'yearly':
        return d.getFullYear().toString();
      default:
        return d.toLocaleDateString();
    }
  };

  // Process data to ensure correct format
  const chartData = sortedData.map(item => ({
    date: item.date,
    inFlow: item.inFlow,
    outFlow: item.outFlow,
  }));

  const series = useMemo(
    () => [
      {
        name: 'Inflow',
        data: chartData.map(d => d.inFlow),
      },
      {
        name: 'Outflow',
        data: chartData.map(d => d.outFlow),
      },
    ],
    [chartData],
  );

  const categories = useMemo(
    () => chartData.map(d => getPeriod(d.date, periodType)),
    [chartData, periodType],
  );

  const options = {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '40%',
        borderRadius: 4,
        distributed: false,
        groups: 2,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 1,
      colors: ['#47873D', '#961D14'],
    },
    xaxis: {
      categories: categories || [
        'Jan 2025',
        'Feb 2025',
        'Mar 2025',
        'Apr 2025',
      ],
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: '#A0AEC0',
          fontSize: '14px',
        },
      },
    },
    yaxis: {
      labels: {
        formatter: value => `${(value / 1000).toFixed(1)}k`,
        style: {
          colors: '#A0AEC0',
          fontSize: '12px',
        },
      },
    },
    colors: ['#71B167', '#C0483F'],
    legend: {
      show: false,
    },
    fill: {
      opacity: 1,
    },
    grid: {
      borderColor: '#f1f1f1',
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    states: {
      hover: {
        filter: {
          type: 'none',
        },
      },
    },
  };

  return (
    <div className="w-full h-[400px]">
      {loading ? (
        <div className="flex justify-center items-center h-full">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-900"></div>
        </div>
      ) : (
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height="100%"
        />
      )}
    </div>
  );
};

export default InvoicesChart;
